import { axiosInstance_modal } from "../redux/axios_instance_modal";

export const get_transactions = async () => {
  try {
    const { data } = await axiosInstance_modal.get("/transactions");
    let d = [];

    data.map((item) => {
      return d.push({ ...item, order_number: item?.order?.order_number });
    });

    return d;
  } catch (error) {}
};
